import { render, staticRenderFns } from "./ApplyMerchantForm.vue?vue&type=template&id=679dcb7a"
import script from "./ApplyMerchantForm.vue?vue&type=script&lang=js"
export * from "./ApplyMerchantForm.vue?vue&type=script&lang=js"
import style0 from "./ApplyMerchantForm.vue?vue&type=style&index=0&id=679dcb7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports